exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active[data-v-74304e6f],\n.slide-leave-active[data-v-74304e6f],\n.fade-enter-active[data-v-74304e6f],\n.fade-leave-active[data-v-74304e6f] {\n  will-change: transform;\n  transition: all 0.5s;\n}\n.slide-enter[data-v-74304e6f],\n.slide-leave-to[data-v-74304e6f] {\n  transform: translateX(-100%);\n}\n.fade-enter[data-v-74304e6f],\n.fade-leave-to[data-v-74304e6f] {\n  opacity: 0;\n}\n", ""]);

// exports
